import Enum from "../../../../../../enums/Enum";

const MyotomesThoracicEnum = new Enum({
    M_T1: {value: "T1 -Finger Abduction"},
});

export default MyotomesThoracicEnum;